import { ApexOnlineMenu, menuItems, menuPermissions } from 'apex-online-menu'
import { MenuItem, SearchAccountsResponsePayload } from 'apex-ui-services'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { getAppConfigSetting } from '../../utils'
import { useAuth } from '../../hooks'
import { RootState } from '../../store'
import { AccountDetails } from '../../types'

const apiUrl: string = getAppConfigSetting('apiUrl') as string

export interface Props {
  menuItems: MenuItem[]
  menuPermissions: any
  menuItemsRequest: (apiUrl: string) => void
  menuPermissionsRequest: (apiUrl: string) => void
  handleSignout: () => void
  accountInformation?: SearchAccountsResponsePayload | null
  accountDetails?: AccountDetails
}

export const ApexMenuComponent = ({
  menuItems,
  menuPermissions,
  accountInformation,
  menuItemsRequest,
  menuPermissionsRequest,
  handleSignout,
  accountDetails,
}: Props) => {
  const { showAppContent } = useAuth()

  useEffect(() => {
    if (showAppContent) {
      menuItemsRequest(apiUrl)
      menuPermissionsRequest(apiUrl)
    }
  }, [menuItemsRequest, menuPermissionsRequest, showAppContent])

  const getLegacyUrl = () => {
    const cookie = document.cookie
    const parts = cookie.split(';')
    const apexURL = parts.find(p => p.includes('apexOnlineURL'))
    if (apexURL) {
      return apexURL.split('URL=')[1]
    }
    return null
  }

  return (
    <ApexOnlineMenu
      items={menuItems}
      userPermissions={menuPermissions}
      legacyUrl={getLegacyUrl()}
      showLogout={showAppContent}
      logout={handleSignout}
      accountNumber={accountInformation?.accountNumber || accountDetails?.accountNumber}
    />
  )
}

const mapDispatchToProps = {
  menuItemsRequest: menuItems.request,
  menuPermissionsRequest: menuPermissions.request,
}

const mapStateToProps = (state: RootState) => {
  const {
    accountDetailsReducer: { accountDetails },
  } = state
  return {
    accountDetails,
    menuItems: menuItems.selectors.menuItemsResults(state),
    menuPermissions: menuPermissions.selectors.menuPermissionsResults(state),
  }
}

export const ApexMenu = connect(mapStateToProps, mapDispatchToProps)(ApexMenuComponent)
